import { createSlice } from '@reduxjs/toolkit'

import { AppReducerState } from '../types'

import appReducers from './appReducers'

const appInitialState: AppReducerState = {
  isErrorModalVisible: false,
  errorModalConfig: null,

  isCartDrawerVisible: false,
  // The cart starts collapsed; the user opens it when they need it
  isCartRailCollapsed: true,
  isMobileDrawerVisible: false,
  isSwitchLanguageModalVisible: false,
  orderDrawerOrderId: null,

  isSignalROnline: false,
}

const appSlice = createSlice({
  name: 'app',
  initialState: appInitialState,
  reducers: appReducers,
})

export const {
  appSetIsErrorModalVisible,
  appShowError,
  appSetIsCartDrawerVisible,
  appSetIsCartRailCollapsed,
  appSetOrderDrawerOrderId,
  appSetIsMobileDrawerVisible,
  appSetIsSwitchLanguageModalVisible,
  appSetIsSignalROnline,
} = appSlice.actions

export default appSlice.reducer
